import { useState } from 'react'
import { Button } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import Breadcrumbs from '../../components/ui/Breadcrumbs'
import RetailerTable from '@/components/retailers/RetailerTable'
import RetailerCreate from '@/components/retailers/RetailerCreate'

export default function Index() {
    const [createOpened, setCreateOpened] = useState(false)

    const breadcrumbs = [{ label: 'Revendeurs' }]

    return (
        <div>
            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                rightSection={
                    <Button
                        leftSection={<IconPlus size={16} />}
                        onClick={() => setCreateOpened(true)}
                    >
                        Nouveau revendeur
                    </Button>
                }
            />
            <RetailerTable />
            <RetailerCreate
                opened={createOpened}
                onClose={() => setCreateOpened(false)}
            />
        </div>
    )
}
